// src/navigationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const showFieldsSlice = createSlice({
  name: "showFields",
  initialState,
  reducers: {
    updateShowFields: (state, action) => {
      return [...action.payload];
    },
    updateShowFieldsByIndex: (state, action) => {
      if (
        action.payload.index !== undefined &&
        !isNaN(parseInt(action.payload.index))
      ) {
        const updatedState = [...state]; // Copy the current state
        updatedState[action.payload.index] = action.payload.toChange; // Update the specific element

        return updatedState; // Return the updated state
      }

      return state; // Return the original state if no update is performed
    },
    resetShowFields: (state, action) => {
      return initialState; // Reset to initial stat
    },
    emptyShowFields: (state, action) => {
      const newState = state.map((e) => ({ ...e, defaultValue: undefined }));
      return newState; // Reset to initial stat
    },
    addHideToParams: (state, action) => {
      const { paramName, values, showValues } = action.payload;
      return state.map((item) => {
        if (values.includes(item[paramName])) {
          return { ...item, hide: true };
        }
        if (showValues.includes(item[paramName])) {
          return { ...item, hide: false };
        }
        return item;
      });
    },
    addDisableToParams: (state, action) => {
      const {
        paramName,
        values,
        showValues,
        field,
        onToggleSetDisabledValueTo,
      } = action.payload;
      // if(field != null && onToggleSetDisabledValueTo != null){
      //   return state.map((item) => {
      //     if (values.includes(item[field])) {
      //       return { ...item, disabled: onToggleSetDisabledValueTo, isRequired: false };
      //     }
      //   })
      // }
      return state.map((item) => {
        if (values.includes(item[paramName])) {
          return { ...item, disabled: true, isRequired: false };
        }
        if (showValues.includes(item[paramName])) {
          return { ...item, disabled: false, isRequired: true };
        }
        return item;
      });
    },
  },
});

export const {
  updateShowFields,
  resetShowFields,
  updateShowFieldsByIndex,
  emptyShowFields,
  addHideToParams,
  addDisableToParams,
} = showFieldsSlice.actions;

export default showFieldsSlice.reducer;
